
<template>
    
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading your data ...
        </div>
        <div v-if="1==2 && loading == false && order.bundles_created == 1">
        <div class="page" v-for="(row, index) in order.bundles" :key="row.id" style="break-after: always;" >
              <div class="columns">
                  <div class="column">
                      <h4  class="title">Order No : {{ order.ponumber }}</h4>
                      <h4 class="title">Bundle No : {{ index+1 }}</h4>
                      <h4 class="title">Bundle Qty : {{ row.qty }}</h4>
                  </div>
                  <div class="column has-text-right">
                      <barcode v-bind:value="'BDL' + padBundleZeros(row.id) + '.'"  format="CODE128">
                          Show this if the rendering fails.
                      </barcode>
                  </div>
              </div>
              <br /><br />

              <div class="columns" >
                  <div class="column">
                      <small>{{ row.qty }} x On Factory Floor</small>
                      <barcode v-bind:value="'FLR' + padBundleZeros(row.id) + '.'"  format="CODE128" width="1" height="50">
                          Show this if the rendering fails.
                      </barcode>
                  </div>
                  <div class="column">
                      <small>{{ row.qty }} x Packing</small>
                      <barcode v-bind:value="'PAC' + padBundleZeros(row.id) + '.'"  format="CODE128" width="1" height="50">
                          Show this if the rendering fails.
                      </barcode>
                  </div>
                  <div class="column">
                      <small>{{ row.qty }} x Warehouse</small>
                      <barcode v-bind:value="'WAR' + padBundleZeros(row.id) + '.'"  format="CODE128" width="1" height="50">
                          Show this if the rendering fails.
                      </barcode>
                  </div>
                  <div class="column">
                      <small>{{ row.qty }} x Stock Take</small>
                      <barcode v-bind:value="'STK' + padBundleZeros(row.id) + '.'"  format="CODE128" width="1" height="50">
                          Show this if the rendering fails.
                      </barcode>
                  </div>
                  <div class="column">
                      <small>{{ row.qty }} x Clipping</small>
                      <barcode v-bind:value="'CLP' + padBundleZeros(row.id) + '.'"  format="CODE128" width="1" height="50">
                          Show this if the rendering fails.
                      </barcode>
                  </div>
                  <div class="column">
                      <small>{{ row.qty }} x Off Factory Floor</small>
                      <barcode v-bind:value="'FIN' + padBundleZeros(row.id) + '.'"  format="CODE128" width="1" height="50">
                          Show this if the rendering fails.
                      </barcode>
                  </div>
              </div>
              
          </div>
        </div>
    </div>
</template>

<style >
h4 {margin-bottom:0.25em !important}
html.has-navbar-fixed-top {padding-top:0px !important}
.page {border:1px #000 solid}
</style>

<script>
import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';
import VueBarcode from 'vue-barcode';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
 name: 'Bundling',
  mixins: [OrderMixin],
  components: {
    'barcode': VueBarcode
  },
  data() {
    
    return {
      order: {orderID: 0},
      area: '',
      loading: false,
      ponumber: '',
      access_token: '',
      sizes: [],
      machines: [],
      machine_id: '',
      order_id : this.$route.params.id
    }
  },
   methods: {
      async getOrder() {
        this.loading=true
        OrderService.getSingleOrder(this.accessToken, this.order_id)
        .then(
          (order => {
            this.$set(this, "order", order);
           
            this.loading=false
            this.working = false

            
          }).bind(this)
        );
      },
      async getSizes() {
        OrderService.getSizes(this.accessToken)
        .then(
            (sizes => {
              
              this.$set(this, "sizes", sizes);
              
            }).bind(this)
          );
      },
      
   },
   mounted() {
       
  },
  computed : {
      sizesWithQtys: function () {  
          let order = this.order
        let sizesWithQtys =  this.sizes.filter(function(u) {
            if( order[u.database_name] + order[u.database_name + '_GK'] > 0) 
            {
               console.log(u)
              return 1
            }
          })

          return sizesWithQtys 
     },
   
  },
  watch: {

   
    
  },
  created() {
     this.getAccessToken()
        .then(() => { 
          
          this.getOrder();

          
        });

        
  },
}
</script>